// Copyright (c) 2026 Solartek LLC. All rights reserved.

import { Suspense } from 'react';
import type { RouteObject } from 'react-router';
import { RequireModule, RequirePermission } from '@/components/layout/protected-route';
import './i18n';
import { RequireSurveillanceLink } from './components/require-link';
import { PageFallback, ProductivityEmployeePage, ProductivityPage } from './pages/lazy';

const guard = (node: React.ReactNode) => (
  <RequireModule modules={['surveillance']}>
    <RequirePermission permissions={['productivity.view', 'productivity.view_team']} any selfServiceTo="/my/productivity">
      <RequireSurveillanceLink><Suspense fallback={<PageFallback />}>{node}</Suspense></RequireSurveillanceLink>
    </RequirePermission>
  </RequireModule>
);

/**
 * Flowza Surveillance in FlowZa Time: /productivity (overview, employees, anomalies) and /productivity/employees/:employeeId —
 * HR with productivity.view (their branches), line managers with productivity.view_team (their reporting line). The employee's
 * own summary is a portal route (/my/productivity, features/portal/routes.tsx).
 */
export const productivityRoutes: RouteObject[] = [
  { path: 'productivity', element: guard(<ProductivityPage />) },
  { path: 'productivity/employees/:employeeId', element: guard(<ProductivityEmployeePage />) },
];
